const getCurrentTime = () => {
  if (typeof window !== 'undefined') {
    return Date.now();
  }
  return new Date().getTime();
};

export const setAuthInfo = async ({
  api,
  cryptoStore,
  requestConfig,
  oldSessionToken,
  isRefreshAuth = false,
}) => {
  const authEndpoint = `authorization/${isRefreshAuth ? 'refresh/' : ''}`;

  const authResponse = await api.get(authEndpoint, {
    isAuthRequest: true,
    headers: isRefreshAuth ? { token: oldSessionToken } : {},
  });

  const responseData = authResponse?.data;
  const sessionToken = responseData?.token;
  const sessionTokenExpirationTime = responseData?.valid_time;

  await cryptoStore?.set('session-token', sessionToken);
  await cryptoStore?.set('session-token-exp', sessionTokenExpirationTime);

  requestConfig.headers.token = sessionToken;
  delete requestConfig.isAuthRequest;

  return requestConfig;
};

export const checkTokenExpiration = async ({
  api,
  cryptoStore,
  requestConfig,
  sessionTokenStored,
}) => {
  const sessionTokenExpTime = await cryptoStore?.get('session-token-exp');
  const now = Math.floor(getCurrentTime() / 1000);

  const isTokenExpired = now > Number(sessionTokenExpTime);

  if (isTokenExpired) {
    const sessionToken = await cryptoStore?.get('session-token');
    return setAuthInfo({
      api,
      cryptoStore,
      requestConfig,
      oldSessionToken: sessionToken,
      isRefreshAuth: true,
    });
  }

  requestConfig.headers.token = sessionTokenStored;
  return requestConfig;
};
